import { SB } from '@play-co/replicant';
import * as PetChatbot from '../../petChatbot';
import { petChatbotScheduledActions } from '../../petChatbot/petChatbot.scheduledActions';
import * as Inventory from '../../inventory';
import { inventoryScheduledActions } from '../../inventory/inventory.scheduledActions';
import * as Pet from '../../pet';
import createScheduledActions from './createScheduledActions';
import daycareScheduledActions from 'src/replicant/daycare/daycare.scheduledActions';
import reengagementScheduledActions from 'src/replicant/reengagement/reengagement.scheduledActions';
import admin from '../../admin/admin.scheduledActions';
import { visitScheduledActions } from 'src/replicant/visit/visit.scheduledActions';
import chatbotScheduledActions from '../../chatbot/chatbot.scheduledActions';
import { giftScheduledActions } from 'src/replicant/gifts/gifts.scheduledActions';
import { cardsScheduledActions } from 'src/replicant/cards/cards.scheduledActions';
import { endSession } from '../actions/endSession.modifier';
import { match2ScheduledActions } from 'src/replicant/match2/match2.scheduledActions';
import { buddiesScheduledActions } from 'src/replicant/buddies/buddies.scheduledActions';
import { jankenScheduledActions } from 'src/replicant/janken/janken.scheduledActions';
import { preEntryScheduledActions } from '../../chatbot/preEntry.scheduledActions';

const inventory = inventoryScheduledActions;
const petChatbot = petChatbotScheduledActions;
const daycare = daycareScheduledActions;
const reengagement = reengagementScheduledActions;
const chatbot = chatbotScheduledActions;

export default createScheduledActions({
  noop: SB.object({}),
  triggerOnGameEnd: SB.unknown(),
  ...petChatbot.schema,
  ...inventory.schema,
  ...daycare.schema,
  ...reengagement.schema,
  ...admin.schema,
  ...visitScheduledActions.schema,
  ...chatbot.schema,
  ...giftScheduledActions.schema,
  ...cardsScheduledActions.schema,
  ...match2ScheduledActions.schema,
  ...buddiesScheduledActions.schema,
  ...jankenScheduledActions.schema,
  ...preEntryScheduledActions.schema,
})({
  /** A blank scheduled action for debug purposes. */
  noop: async () => undefined,

  triggerOnGameEnd: async (state, _, api) => {
    // deprecated
    // TODO: remove this acheduled action in a future release
    await endSession(state, api);
  },

  ...petChatbot.actions,
  ...inventory.actions,
  ...daycare.actions,
  ...reengagement.actions,
  ...admin.actions,
  ...visitScheduledActions.actions,
  ...chatbot.actions,
  ...giftScheduledActions.actions,
  ...cardsScheduledActions.actions,
  ...match2ScheduledActions.actions,
  ...buddiesScheduledActions.actions,
  ...jankenScheduledActions.actions,
  ...preEntryScheduledActions.actions,
});
